import axiosInstance from '@/store/axios';
import { rejectErrorApiV2 } from '@/store/helper';

const defaultProfile = {
  audio_template: {},
  video_template: {
    codec: '',
    streams: [],
  },
};

export default {
  namespaced: true,
  state: {
    profiles: [],
    selectedProfile: defaultProfile,
  },
  getters: {
    getProfiles(state) {
      return state.profiles;
    },
    getProfile(state) {
      return state.selectedProfile;
    },
  },
  mutations: {
    setProfiles(state, profiles) {
      state.profiles = profiles;
    },
    setSelectedProfile(state, profile) {
      state.selectedProfile = profile;
    },
  },
  actions: {
    getProfiles({ commit }) {
      return axiosInstance.get('/api/2/profiles')
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          commit('setProfiles', result.data.profiles);
          return result.data.profiles;
        })
        .catch(error => Promise.reject(error));
    },
    getProfile({ commit }, id) {
      commit('setSelectedProfile', defaultProfile);
      return axiosInstance.get(`/api/2/profiles/${id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return commit('setSelectedProfile', result.data.profile);
        })
        .catch(error => Promise.reject(error));
    },
    createProfile({ commit }, profile) {
      return axiosInstance({
        method: 'POST',
        url: '/api/2/profiles',
        data: profile,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data.profile;
        })
        .catch(error => Promise.reject(error));
    },
    updateProfile({ commit }, profile) {
      return axiosInstance({
        method: 'PUT',
        url: `/api/2/profiles/${profile.id}`,
        data: profile,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data.profile;
        })
        .catch(error => Promise.reject(error));
    },
    deleteProfile({ commit }, id) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/2/profiles/${id}`,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          return result.data;
        })
        .catch(error => Promise.reject(error));
    },
  },
};
